import { LOCALIZED_PAGES } from '@/constants';

/**
 * Check if a page path supports localization.
 * Uses LOCALIZED_PAGES from config/localeRouting.json (via @/constants).
 */
export const isPageLocalized = (path: string): boolean => {
	return LOCALIZED_PAGES.includes(path);
};
